import { createEffect } from "solid-js";
import { RouteSectionProps } from "@solidjs/router";

import AppRouter from "@repo/utils-solid/AppRouter";

import { useOverlaysController } from "~/overlays";
import { useUser } from "~/state/features/user";

export default function AuthLayout({ children }: D<RouteSectionProps>) {
  const overlays = useOverlaysController();

  const [user] = useUser();

  createEffect(() => {
    if (user.authenticated())
      AppRouter.replace(
        new URLSearchParams(AppRouter.search).get("redirect") ||
          user.status.route()!
      );
  });

  createEffect(() => {
    if (user.mfaRequired())
      requestAnimationFrame(() =>
        overlays.open("auth/Mfa", { purpose: "userLogin" })
      );
  });

  return <>{children}</>;
}
